import type {CodexNotification,ThreadRecord} from '@reados/contracts';

const object=(value:unknown):Record<string,unknown>|null=>value&&typeof value==='object'&&!Array.isArray(value)?value as Record<string,unknown>:null;
const timestamp=(value:unknown)=>typeof value==='string'?Date.parse(value):NaN;

/** Only the API-owned Web thread record can rename a conversation surface. */
export function threadMetadataFromEvent(event:CodexNotification,ownerThreadId:string,nativeThreadId?:string):ThreadRecord|null {
  if(event.method!=='reados/thread'||event.params.ownerThreadId!==undefined&&event.params.ownerThreadId!==ownerThreadId)return null;
  const thread=object(event.params.thread);
  if(!thread||thread.id!==ownerThreadId||typeof thread.title!=='string'||!thread.title.trim()||
    !Number.isFinite(timestamp(thread.createdAt))||!Number.isFinite(timestamp(thread.updatedAt))||
    thread.codexThreadId!==undefined&&(typeof thread.codexThreadId!=='string'||!thread.codexThreadId)||
    nativeThreadId!==undefined&&thread.codexThreadId!==nativeThreadId)return null;
  return thread as unknown as ThreadRecord;
}

/** Slow HTTP snapshots and replayed events must not replace a newer title. */
export function mergeThreadMetadata(current:ThreadRecord|null,incoming:ThreadRecord):ThreadRecord {
  if(!current||current.id!==incoming.id)return incoming;
  const before=timestamp(current.updatedAt),after=timestamp(incoming.updatedAt);
  if(Number.isFinite(before)&&(!Number.isFinite(after)||after<before))return current;
  const preserveTitle=current.titleCustomized&&!incoming.titleCustomized||
    before===after&&current.titleGenerated&&!incoming.titleGenerated&&!incoming.titleCustomized;
  return {...current,...incoming,...(preserveTitle?{title:current.title,titleCustomized:current.titleCustomized,titleGenerated:current.titleGenerated}:{})};
}

/** Membership comes from the authoritative catalog; metadata never resurrects a deleted row. */
export function mergeThreadCatalog(current:ThreadRecord[],incoming:ThreadRecord[]):ThreadRecord[] {
  const previous=new Map(current.map(thread=>[thread.id,thread]));
  return incoming.map(thread=>mergeThreadMetadata(previous.get(thread.id)??null,thread));
}
